import {useEffect, useRef} from 'react';
import {useGridApiRef} from '@mui/x-data-grid-pro';

import {shouldGroupExpand} from '../helpers/ContentHierarchyDataHelper';

export const useDataGridExpansionState = (rows) => {
    const apiRef = useGridApiRef();
    const detailPanelExpandedRowIds = useRef([]);
    const isUpdateComplete = useRef(false);

    useEffect(() => {
        if (!apiRef.current) return;

        const handleRowExpansionChange = (params) => {
            const {id, childrenExpanded} = params;

            if (childrenExpanded) {
                if (!detailPanelExpandedRowIds.current.includes(id)) {
                    detailPanelExpandedRowIds.current.push(id);
                }
            } else {
                detailPanelExpandedRowIds.current = detailPanelExpandedRowIds.current.filter(rowId => rowId !== id);
            }
        };

        return apiRef.current.subscribeEvent('rowExpansionChange', handleRowExpansionChange);
    }, [apiRef]);

    useEffect(() => {
        if (rows.length > 0 && detailPanelExpandedRowIds.current.length > 0) {
            isUpdateComplete.current = true;
        }
    }, [rows]);

    useEffect(() => {
        if (detailPanelExpandedRowIds.current.length > 0 && isUpdateComplete.current) {
            let expandedIds = [...new Set(detailPanelExpandedRowIds.current)];
            expandedIds.forEach(id => {
                const currentNode = apiRef.current.getRowNode(id);
                if (currentNode && currentNode?.type !== "leaf") {
                    apiRef.current.setRowChildrenExpansion(id, true)
                }
            });
            isUpdateComplete.current = false;
        }
    }, [isUpdateComplete.current, apiRef]);

    const isGroupExpandedByDefault = (params) => {
        return shouldGroupExpand(params, new Set([...detailPanelExpandedRowIds.current]));
    };

    const expandAll = () => detailPanelExpandedRowIds.current = rows.map(row => row.id);
    const collapseAll = () => detailPanelExpandedRowIds.current = [];

    return {
        apiRef,
        detailPanelExpandedRowIds,
        isUpdateComplete,
        isGroupExpandedByDefault,
        expandAll,
        collapseAll,
    };
};